<template>
  <div>
    <b-modal
      id="detail-master-job-title-modal"
      no-close-on-backdrop
      size="lg"
      title="Detail Job Title"
    >
      <b-row>
        <b-col cols="12" xl="12">
          <table class="table table-bordered table-sm table-striped">
            <tbody>
              <tr>
                <th><span class="font-weight-bold">Nama Jabatan</span></th>
                <td>{{ result.positionName }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Job Title</span></th>
                <td>{{ result.titleName }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Posisi</span></th>
                <td>{{ result.positionName }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Sub Job Grade</span></th>
                <td>{{ result.band ? result.band.bandName : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Deskripsi</span></th>
                <td>{{ result.description }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Departement</span></th>
                <td>{{ result.department ? result.department.departmentName : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Management</span></th>
                <td>{{ result.department ? result.department.parentManagement.managementName : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Role</span></th>
                <td>

                  <div v-if="result.jobTitleRoleResponseDtos">
                  <ul v-if="result.jobTitleRoleResponseDtos.length > 0" style="margin: 0;padding-left:16px;">
                    <li v-for="item of result.jobTitleRoleResponseDtos" :key="item.id">{{ item.jobTitle.titleName }}</li>
                  </ul>
                  </div>

                </td>
              </tr>
              
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { BCol, BAvatar, BRow } from "bootstrap-vue";

export default {
  components: {
    BCol,
    BAvatar,
    BRow,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["result"],
};
</script>
